import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, TableHead, TableBody, TableContainer, TableCell, TableRow, TextField, Button, Select, MenuItem, InputLabel, FormControl, Box, Checkbox, FormControlLabel, useMediaQuery } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import "../../components/Styles/Pages.css";
import AddIcon from '@mui/icons-material/Add';
import { API_BASE } from '../../utils/api';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";
import { formatCurrency } from "../../utils/currency";
import { InputAdornment } from '@mui/material';
import { Editor } from 'primereact/editor';
import { AddCircleOutline, RemoveCircleOutline, ExpandMore, ExpandLess } from "@mui/icons-material";
import { AutoComplete } from "primereact/autocomplete";

import {
  Card,
  CardContent,
  CardMedia,
  Typography,

  Grid
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
function AddProduct() {
  const { id } = useParams();
  const [imagePreview, setImagePreview] = useState(null);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  //const [isSaved, setIsSaved] = useState(false);
  const [isVeg, setIsVeg] = useState(false);
  const [isofferPricemodified, setIsofferPricemodified] = useState(false);
  const [offerappliedcount, setofferappliedcount] = useState(0);
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('open');
  const [isEditing, setIsEditing] = useState(false);

  const MAX_FILE_SIZE_MB = 5;
  const ALLOWED_FILE_TYPES = ["image/jpeg", "image/png", "image/gif"];
  const MAX_IMAGES = 5;
  const [errors, setErrors] = useState({});
  const [isMultiple, setIsMultiple] = useState(false);
  const [specSuggestions, setSpecSuggestions] = useState([]);
  const [filteredKeys, setFilteredKeys] = useState([]);
  const [filteredValues, setFilteredValues] = useState([]);
  const [expanded, setExpanded] = useState(true)

  //const isMobile = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    productName: '',
    productNumber: '',
    category: '',
    subcategory: '',
    subcategoryName: '',
    productDetails: '',
    keyFeatures: "",
    netQuantity: '',
    unit: '',
    manufactureDate: '',
    expiryDate: '',
    price: '',
    offerPrice: '',
    discountPercentage: '',
    images: [],
    isVeg,
    isVisible: false,
    productSpecifications: [{ key: "", value: "" }],
  });
const [multipleProducts, setMultipleProducts] = useState([
  { quantity: '', unit: '', price: '', subTitle: '' }
]);
  useEffect(() => {
    const fetchSpecs = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/products/specifications/suggestions`);
        setSpecSuggestions(res.data || []);
      } catch (err) {
        console.error("Error fetching specifications:", err);
      }
    };
    fetchSpecs();
  }, []);

  const searchKeys = (event) => {
    if (event.query.length < 3) { // clear suggestions if less than 3 characters
      setFilteredKeys([]);
      return;
    }

    const results = specSuggestions
      .map((s) => s.key)
      .filter((k) => k.toLowerCase().includes(event.query.toLowerCase()));
    setFilteredKeys(results);
  };


  const searchValues = (event, key) => {
    if (event.query.length < 3) {
      setFilteredValues([]);
      return;
    }

    const spec = specSuggestions.find((s) => s.key === key);
    const results = spec
      ? spec.values.filter((v) => v.toLowerCase().includes(event.query.toLowerCase()))
      : [];
    setFilteredValues(results);
  };



  useEffect(() => {
    const fetchCategoriesAndProduct = async () => {
      try {
        // Fetch all categories
        const categoryResponse = await axios.get(`${API_BASE}/api/categories/all`);
        setCategories(categoryResponse.data);

        if (id) {
          // Fetch product details for editing
          const productResponse = await axios.get(`${API_BASE}/api/products/view/${id}`);
          const product = productResponse.data;
          const variants = product.variants || [];
          const isMultipleVariants = variants.length > 1;
          const singleVariant = variants.length === 1 ? variants[0] : null;

          const price = isMultipleVariants ? '' : (product.price || singleVariant?.price || '');

          setFormData({
            productName: product.productName || '',
            productNumber: product.productNumber || '',
            productDetails: product.productDetails || '',
            category: product.category || '',
            subcategory: product.subcategory || '',
            isVisible: product.isVisible === true,
            netQuantity: singleVariant ? singleVariant.quantity : '',
            unit: isMultipleVariants ? '' : (product.unit || singleVariant?.unit || ''),
            price,
            keyFeatures: product.keyFeatures || "",
            images: product.images || [],
            productSpecifications: product.productSpecifications?.length
              ? product.productSpecifications
              : [{ key: "", value: "" }],
          });

          setIsVeg(product.isVeg === true);

          setMultipleProducts(
            isMultipleVariants
              ? variants.map(variant => ({
                quantity: variant.quantity,
                unit: variant.unit,
                price: variant.price,
                subTitle: variant.subTitle || '',
              }))
              : []
          );

          setStatus(product.status);
          setIsMultiple(isMultipleVariants);

          if (product.category) {
            fetchSubcategories(product.category);
          }
        } else {

          const response = await axios.get(`${API_BASE}/api/products/generate-product-number`);
          const { nextProductNumber } = response.data;
          setFormData(prevFormData => ({
            ...prevFormData,
            productNumber: nextProductNumber
          }));
        }
      } catch (err) {
        console.error('Error fetching categories or product:', err);
      }
    };

    fetchCategoriesAndProduct();
  }, [id]);







  const fetchSubcategories = async (categoryId) => {
    try {
      const response = await axios.get(`${API_BASE}/api/subcategory/${categoryId}`);
      setSubcategories(response.data);
    } catch (err) {
      console.error('Error fetching subcategories:', err);
    }
  };
  useEffect(() => {
    //console.log("Updated Form Data:", formData);
  }, [formData]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.productName) newErrors.productName = "Product Name is required.";
    if (!formData.productNumber) newErrors.productNumber = "Product Number is required.";
    if (!formData.category) newErrors.category = "Category is required.";
    if (!formData.subcategory) newErrors.subcategory = "Subcategory is required.";
    if (!formData.description) newErrors.description = "Description is required.";
    if (!formData.netQuantity) newErrors.netQuantity = "Net Quantity is required.";
    if (!formData.unit) newErrors.unit = "Unit is required.";
    if (!formData.manufactureDate) newErrors.manufactureDate = "Manufacture Date is required.";
    if (!formData.expiryDate) newErrors.expiryDate = "Expiry Date is required.";


    if (!formData.price) newErrors.price = "Price is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAvailabilityChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      isAvailable: e.target.checked,
    }));
  };
  const handleCategoryChange = async (e) => {
    const selectedCategoryId = e.target.value;
    const selectedCategory = categories.find(cat => cat._id === selectedCategoryId);

    setFormData((prev) => ({ ...prev, category: selectedCategoryId, subcategory: "", subcategoryName: "" }));

    if (selectedCategoryId) {
      try {
        const response = await axios.get(`${API_BASE}/api/subcategory/${selectedCategoryId}`);
        const subcategoriesData = response.data;
        // console.log("Fetched Subcategories for Category:", subcategoriesData);

        setSubcategories(subcategoriesData);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
        setSubcategories([]);
      }
    } else {
      setSubcategories([]);
    }


  };
  useEffect(() => {
    const { price, offerPrice, discountPercentage } = formData;

    if (price) {
      if (isofferPricemodified) {
        if (offerPrice) {
          const calculatedDiscount = ((price - offerPrice) / price) * 100;
          setFormData(prevData => ({
            ...prevData,
            discountPercentage: Math.round(calculatedDiscount)
          }));
        } else {

          setFormData(prevData => ({
            ...prevData,
            discountPercentage: ""
          }));
        }
      } else {
        if (discountPercentage) {
          const calculatedOfferPrice = price * (1 - discountPercentage / 100);
          setFormData(prevData => ({
            ...prevData,
            offerPrice: Math.round(calculatedOfferPrice)
          }));
        } else {

          setFormData(prevData => ({
            ...prevData,
            offerPrice: ""
          }));
        }
      }
    }
  }, [formData.price, formData.offerPrice, formData.discountPercentage, isofferPricemodified]);



  const capitalizeText = (text) => {
    const excludedWords = ['the', 'of', 'and', 'in', 'to', 'a', 'an'];
    return text
      .split(' ')
      .map((word, index) => {

        if (excludedWords.includes(word.toLowerCase()) && index !== 0) {
          return word.toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  };

  const handleChange = (event) => {
    const { name, type, value, checked } = event.target;

    let formattedValue = type === "checkbox" ? checked : value;


    if (name === "productName" || name === "productDetails") {
      formattedValue = capitalizeText(value);
    }


    if (name === "offerPrice") {
      setIsofferPricemodified(true);
      setofferappliedcount((prev) => prev + 1);
    } else if (name === "discountPercentage") {
      setIsofferPricemodified(false);
      setofferappliedcount((prev) => prev + 1);
    }


    setFormData((prevData) => ({
      ...prevData,
      [name]: formattedValue,
    }));
  };


  const handleEdit = () => {

    setIsEditing(true);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    let newErrors = {};
    let validFiles = [];


    if ((formData.images?.length || 0) + files.length > MAX_IMAGES) {
      toast.warning(`You can upload a maximum of ${MAX_IMAGES} images.`);
      return;
    }

    files.forEach((file) => {

      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        newErrors.images =
          "Invalid file format. Only JPG, PNG, and GIF are allowed.";
        return;
      }


      const fileSizeMB = file.size / (1024 * 1024);
      if (fileSizeMB > MAX_FILE_SIZE_MB) {
        newErrors.images = `File size exceeds ${MAX_FILE_SIZE_MB}MB. Please upload smaller files.`;
        return;
      }

      validFiles.push(file);
    });

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});


    setFormData((prevData) => ({
      ...prevData,
      images: [...(prevData.images || []), ...validFiles],
    }));
  };




  const handleRemoveImage = async (index) => {
    const imageToRemove = formData.images[index];

    if (typeof imageToRemove === "string" && isEditing) {
      try {
        await axios.delete(`${API_BASE}/api/products/${id}/remove-image`, {
          data: { imagePath: imageToRemove },
        });
        toast.success("Image removed successfully");
      } catch (err) {
        console.error(err);
        toast.error("Failed to remove image");
        return;
      }
    }


    setFormData((prevData) => {
      const updatedImages = [...prevData.images];
      updatedImages.splice(index, 1);
      return { ...prevData, images: updatedImages };
    });

    setImagePreviews((prev) => {
      const updatedPreviews = [...prev];
      updatedPreviews.splice(index, 1);
      return updatedPreviews;
    });
  };


  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleCheckboxChange = (e) => {
  setIsMultiple(e.target.checked);

  if (e.target.checked && status !== "open" && isEditing) {
    const newVariant = {
      quantity: formData.netQuantity || "",
      unit: formData.unit || "",
      price: formData.price || "",
      subTitle: formData.subTitle || ""
    };

    setMultipleProducts(prevProducts => [...prevProducts, newVariant]);

    setFormData({
      ...formData,
      netQuantity: "",
      unit: "",
      price: "",
      subTitle: ""
    });
  }
};

const handleMultipleChange = (index, e) => {
  const { name, value } = e.target;

  setMultipleProducts(prevProducts => {
    return prevProducts.map((product, i) => {
      if (i !== index) return product;
      return { ...product, [name]: value };
    });
  });
};



const addProductRow = () => {
  if (!isMultiple) return;

  setMultipleProducts(prevProducts => [
    ...prevProducts,
    { quantity: "", unit: "", price: "", subTitle: "" }
  ]);
};

  const handleVegChange = (e) => {
    setIsVeg(e.target.checked);
    console.log("Checkbox checked:", e.target.checked);
  };

  const handleStatusChange = async (action) => {
    try {
      console.log("Sending username:", localStorage.getItem("username"));

      const username = localStorage.getItem('username');

      if (!username) {
        toast.error("Username is missing. Please log in again.");
        return;
      }

      const response = await axios.post(`${API_BASE}/api/products/${action}/${id}`, {
        username: username
      });

      toast.success(response.data.message);
      navigate('/product');
      if (action === 'accept') setStatus('approved');
      if (action === 'reject') setStatus('rejected');
    } catch (err) {
      console.error("Error:", err.response?.data || err.message);
      toast.error(err.response?.data?.message || 'Failed to update product status');
    }
  };


  const handleSave = () => {

  };

  const handleSpecificationChange = (index, field, value) => {
    const updatedSpecs = [...formData.productSpecifications];
    updatedSpecs[index][field] = value;
    setFormData({ ...formData, productSpecifications: updatedSpecs });
  };

  const addSpecification = () => {
    setFormData({
      ...formData,
      productSpecifications: [...formData.productSpecifications, { key: "", value: "" }],
    });
  };

  const removeSpecification = (index) => {
    const updatedSpecs = formData.productSpecifications.filter((_, i) => i !== index);
    setFormData({ ...formData, productSpecifications: updatedSpecs });
  };

  const convertQuillHtmlToStandard = (quillHtml) => {
    if (!quillHtml) return quillHtml;

    let standardHtml = quillHtml.replace(
      /<ol>([\s\S]*?)<\/ol>/g,
      (match, content) => {
        if (content.includes('data-list="bullet"')) {
          const cleanedContent = content.replace(
            /<li data-list="bullet"><span class="ql-ui" contenteditable="false"><\/span>/g,
            '<li>'
          );
          return `<ul>${cleanedContent}</ul>`;
        } else {
          const cleanedContent = content.replace(
            /<li data-list="ordered"><span class="ql-ui" contenteditable="false"><\/span>/g,
            '<li>'
          );
          return `<ol>${cleanedContent}</ol>`;
        }
      }
    );

    return standardHtml;
  };


 const handleSubmit = async (e) => {
  e.preventDefault();
  console.log("isVeg before submitting:", isVeg);

  // Validate product name
  if (!formData.productName || formData.productName.trim() === "") {
    toast.warning("Product name is required.");
    return;
  }

  // Validate product details
  if (!formData.productDetails || formData.productDetails.trim() === "") {
    toast.warning("Product Details is required.");
    return;
  }

  // Validate key features
  if (!formData.keyFeatures || formData.keyFeatures.trim() === "" || formData.keyFeatures === "<p><br></p>") {
    toast.warning("Key Features is required.");
    return;
  }

  // Validate product specifications
  if (
    !formData.productSpecifications.length ||
    formData.productSpecifications.some((spec) => !spec.key.trim() || !spec.value.trim())
  ) {
    toast.warning("At least one valid product specification is required.");
    return;
  }

  // Validate category
  if (!formData.category || formData.category === "" || formData.category === "Select") {
    toast.warning("Please select a category.");
    return;
  }

  // Validate subcategory
  if (!formData.subcategory || formData.subcategory === "" || formData.subcategory === "Select") {
    toast.warning("Please select a subcategory.");
    return;
  }

  // Validate multiple products if isMultiple is true
  if (isMultiple) {
    if (!multipleProducts || multipleProducts.length === 0) {
      toast.warning("Please add at least one product variant.");
      return;
    }

    for (let i = 0; i < multipleProducts.length; i++) {
      const product = multipleProducts[i];
      
      if (!product.quantity || isNaN(product.quantity) || Number(product.quantity) <= 0) {
        toast.warning(`Row ${i + 1}: Quantity is required and must be greater than 0.`);
        return;
      }
      
      if (!product.unit || product.unit === "" || product.unit === "Select") {
        toast.warning(`Row ${i + 1}: Please select a unit.`);
        return;
      }
      
      if (!product.price || isNaN(product.price) || Number(product.price) <= 0) {
        toast.warning(`Row ${i + 1}: Price is required and must be greater than 0.`);
        return;
      }
    }
  } else {
    // Validate single product variant
    if (!formData.unit || formData.unit === "" || formData.unit === "Select") {
      toast.warning("Please select a unit.");
      return;
    }

    if (!formData.netQuantity || isNaN(formData.netQuantity) || Number(formData.netQuantity) <= 0) {
      toast.warning("Net quantity is required and must be greater than 0.");
      return;
    }

    if (!formData.price || isNaN(formData.price) || Number(formData.price) <= 0) {
      toast.warning("Price is required and must be greater than 0.");
      return;
    }
  }

  // Validate images for new products
  if (status === "open") {
    if (!formData.images || formData.images.length === 0) {
      toast.warning("Please upload at least one image.");
      return;
    }

    const MAX_FILE_SIZE_MB = 5;
    const ALLOWED_FILE_TYPES = ["image/jpeg", "image/png", "image/gif"];

    for (const file of formData.images) {
      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        toast.warning("Invalid file format. Only JPG, PNG, and GIF are allowed.");
        return;
      }

      const fileSizeMB = file.size / (1024 * 1024);
      if (fileSizeMB > MAX_FILE_SIZE_MB) {
        toast.warning(`File size exceeds ${MAX_FILE_SIZE_MB}MB. Please upload smaller files.`);
        return;
      }
    }

    // Check if product already exists
    try {
      const checkResponse = await axios.post(`${API_BASE}/api/products/check-product`, {
        productName: formData.productName,
        productNumber: formData.productNumber,
      });

      if (checkResponse.data.exists) {
        toast.warning("A product with the same name or number already exists.");
        return;
      }
    } catch (err) {
      console.error("Error checking product:", err.response ? err.response.data : err.message);
      toast.error("Error: " + (err.response ? err.response.data.message : err.message));
      return;
    }
  }

  // Submit the form
  try {
    let response;
    const data = new FormData();

    // Append form data
    Object.keys(formData).forEach((key) => {
      if (key !== "variants" && key !== "images" && key !== "productSpecifications") {
        if (typeof formData[key] === "boolean") {
          data.append(key, formData[key] ? "true" : "false");
        } else if (formData[key] !== undefined && formData[key] !== null) {
          // Convert Quill HTML to standard HTML for keyFeatures
          if (key === "keyFeatures") {
            data.append(key, convertQuillHtmlToStandard(formData[key]));
          } else {
            data.append(key, formData[key]);
          }
        }
      }
    });

    // Append product specifications
    data.append("productSpecifications", JSON.stringify(formData.productSpecifications));

    // Append isVeg
    data.append("isVeg", isVeg ? "true" : "false");

    // Prepare variants data
    const variantsData = isMultiple
      ? multipleProducts.map(product => ({
          quantity: product.quantity,
          unit: product.unit,
          price: product.price,
          subTitle: product.subTitle || '',
        }))
      : [
          {
            quantity: formData.netQuantity,
            unit: formData.unit,
            price: formData.price,
            subTitle: formData.subTitle || '',
          },
        ];

    // Append variants
    data.append("variants", JSON.stringify(variantsData));
    data.append("username", localStorage.getItem("username"));

    // Append images
    formData.images.forEach((file) => {
      data.append("images", file);
    });

    // Submit based on edit or create mode
    if (isEditing && id) {
      response = await axios.put(`${API_BASE}/api/products/${id}`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 200) {
        toast.success("Product updated successfully");
        setTimeout(() => navigate("/product"), 2000);
        setIsEditing(false);
      } else {
        toast.error("Failed to update product");
      }
    } else {
      response = await axios.post(`${API_BASE}/api/products/add-product`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 201) {
        toast.success("Product submitted");
        setTimeout(() => navigate("/product"), 2000);
        setStatus("pending");
      } else {
        toast.error("Failed product already exist");
      }
    }
  } catch (err) {
    console.error("Error submitting product:", err.response ? err.response.data : err.message);
    toast.error("Error: " + (err.response ? err.response.data.message : err.message));
  }
};




  return (

    <div className="container">
      <ToastContainer position="top-center" autoClose={3000} />

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <IconButton
          onClick={() => navigate('/product')}
          className="back-button"
          style={{
            backgroundColor: '#e0e0e0',
            border: '1px solid #ccc',
            borderRadius: '50%',
            padding: '5px',
            color: '#333',
          }}
        >
          <KeyboardBackspaceIcon fontSize="medium" />
        </IconButton>

        <h5 className="heading">
          {status === "open" ? "Add Product" : status === "pending" ? "Verify Product" : "Edit Product"}
        </h5>
      </div>



      <form className='form'>

        <Box mb={3} display="flex" gap={2}>
          <TextField
            fullWidth
            variant="filled"
            label="Product Name"
            value={formData.productName}
            onChange={handleChange}
            name="productName"
            error={!!errors.productName}
            helperText={errors.productName}
            disabled={status !== 'open' && !isEditing}
          />
          <TextField
            fullWidth
            variant="filled"
            label="Product Number"
            value={formData.productNumber}
            onChange={handleChange}
            name="productNumber"
            error={!!errors.productNumber}
            helperText={errors.productNumber}
            InputProps={{ readOnly: true }}
          />
        </Box>

        <Box mb={3} display="flex" gap={2}>
          <FormControl fullWidth variant="filled">
            <InputLabel>Category</InputLabel>
            <Select
              value={formData.category}
              onChange={handleCategoryChange}
              name="category"
              disabled={status !== 'open' && !isEditing}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 48 * 5 + 8,
                    overflowY: 'auto',
                  },
                },
              }}
            >
              {categories.map((cat) => (
                <MenuItem key={cat._id} value={cat._id}>
                  {cat.name}

                </MenuItem>
              ))}
            </Select>
            {errors.category && <p className='error-text' >{errors.category}</p>}
          </FormControl>

          <FormControl fullWidth variant="filled">
            <InputLabel>Subcategory</InputLabel>
            <Select
              value={formData.subcategory || ''}
              onChange={handleChange}
              name="subcategory"
              disabled={status !== 'open' && !isEditing}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 48 * 5 + 8,
                    overflowY: 'auto',
                  },
                },
              }}

            >
              {subcategories.map((sub) => (
                <MenuItem key={sub._id} value={sub._id}>
                  {sub.subCat}
                </MenuItem>
              ))}
            </Select>
            {errors.subcategory && <p className='error-text'>{errors.subcategory}</p>}
          </FormControl>

        </Box>
        <Box mb={3}>
          <TextField
            fullWidth
            multiline
            rows={4}
            variant="filled"
            label="Product Details"
            value={formData.productDetails}
            onChange={handleChange}
            name="productDetails"
            error={!!errors.productDetails}
            helperText={errors.productDetails}
            disabled={status !== 'open' && !isEditing}
          />
        </Box>
        <Box mb={3}>
          <Typography variant="subtitle1" gutterBottom>
            Key Features
          </Typography>
          <Editor
            value={formData.keyFeatures || ''}
            onTextChange={(e) => {
              const convertedHtml = convertQuillHtmlToStandard(e.htmlValue);
              setFormData({ ...formData, keyFeatures: convertedHtml });
            }}
            inline
            readOnly={status !== 'open' && !isEditing}
            spellCheck={false}
            style={{
              minHeight: '150px',
              padding: '8px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              backgroundColor: status !== 'open' && !isEditing ? '#f5f5f5' : '#fff',
              pointerEvents: status !== 'open' && !isEditing ? 'none' : 'auto',
              color: status !== 'open' && !isEditing ? '#888' : '#000',
            }}
            headerTemplate={
              <span className="ql-formats">
                <button className="ql-bold"></button>
                <button className="ql-italic"></button>
                <button className="ql-underline"></button>
                <button className="ql-list" value="ordered"></button>
                <button className="ql-list" value="bullet"></button>
                <button className="ql-link"></button>
                <button className="ql-blockquote"></button>
              </span>
            }
          />
          <style>
            {`
          .ql-toolbar.ql-snow {
            pointer-events: ${status !== 'open' && !isEditing ? 'none' : 'auto'} !important;
            opacity: ${status !== 'open' && !isEditing ? '0.5' : '1'};
          }
          .ql-editor[contenteditable="false"] {
            background: #f5f5f5;
            color: #888;
          }
          .ql-editor {
            spellcheck: false;
          }
        `}
          </style>
          {errors.keyFeatures && (
            <p style={{ color: 'red', marginTop: '4px' }}>{errors.keyFeatures}</p>
          )}
        </Box>

        <Box mb={3}>

          <Box className="spec-header">
            <Typography variant="subtitle1" gutterBottom>
              Product Specifications
            </Typography>
            <IconButton onClick={() => setExpanded(!expanded)}>
              {expanded ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Box>


          {expanded && (
            <>
              {formData.productSpecifications.map((spec, index) => (
                <Box
                  key={index}
                  display="flex"
                  alignItems="center"
                  gap={2}
                  mb={2}
                >
                  <AutoComplete
                    value={spec.key}
                    suggestions={filteredKeys}
                    completeMethod={searchKeys}
                    onChange={(e) =>
                      handleSpecificationChange(index, "key", capitalizeText(e.value))
                    }
                    placeholder="e.g. Brand"
                    disabled={status !== "open" && !isEditing}
                    style={{ width: "100%" }}
                    inputStyle={{
                      width: "100%",
                      padding: "16px 12px",
                      boxShadow: "none",
                      fontSize: "1.1rem",
                      backgroundColor: "#fff",
                      outline: "none",
                    }}
                  />

                  <AutoComplete
                    value={spec.value}
                    suggestions={filteredValues}
                    completeMethod={(e) => searchValues(e, spec.key)}
                    onChange={(e) =>
                      handleSpecificationChange(index, "value", capitalizeText(e.value))
                    }
                    placeholder="e.g. Samsung"
                    disabled={status !== "open" && !isEditing}
                    style={{ width: "100%" }}
                    inputStyle={{
                      width: "100%",
                      padding: "16px 12px",
                      boxShadow: "none",
                      fontSize: "1.1rem",
                      backgroundColor: "#fff",
                      outline: "none",
                    }}
                  />

                  {formData.productSpecifications.length > 1 && (
                    <IconButton
                      color="error"
                      onClick={() => removeSpecification(index)}
                      disabled={status !== "open" && !isEditing}
                    >
                      <RemoveCircleOutline />
                    </IconButton>
                  )}
                </Box>
              ))}

              <Button
                variant="outlined"
                startIcon={<AddCircleOutline />}
                onClick={addSpecification}
                disabled={status !== "open" && !isEditing}
              >
                Add
              </Button>
            </>
          )}
        </Box>






        <div className="d-flex align-items-center mb-3">
          <div className="form-check me-4">
            <input
              type="checkbox"
              className="form-check-input"
              checked={isMultiple}
              onChange={handleCheckboxChange}
              disabled={status !== 'open' && !isEditing}
            />
            <label className="form-check-label">Is Multiple</label>
          </div>
          {/* <div className="form-check">
                        <input
                            type="checkbox"
                            className="form-check-input"
                            checked={isVeg}
                            onChange={handleVegChange}
                            disabled={status !== 'open' && !isEditing}
                        />
                        <label className="form-check-label">Veg</label>
                    </div> */}
        </div>

        {!isMultiple && (
          <>

            <Box mb={3} display="flex" gap={2}>
              <TextField
                fullWidth
                variant="filled"
                label="Net Quantity"
                value={formData.netQuantity}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
                    handleChange(e);
                  }
                }}
                name="netQuantity"
                error={!!errors.netQuantity}
                helperText={errors.netQuantity}
                disabled={status !== 'open' && !isEditing}
                inputProps={{ inputMode: 'decimal' }}
              />
              <FormControl fullWidth variant="filled">
                <InputLabel>Unit</InputLabel>
                <Select
                  value={formData.unit}
                  onChange={handleChange}
                  name="unit"
                  disabled={status !== 'open' && !isEditing}
                >
                  <MenuItem value="Liter">Liter</MenuItem>
                  <MenuItem value="Milliliter">Milliliter</MenuItem>
                  <MenuItem value="Pack of">Pack of</MenuItem>
                  <MenuItem value="Gram">Gram</MenuItem>
                  <MenuItem value="Kilogram">Kilogram</MenuItem>
                  <MenuItem value="piece ">Piece</MenuItem>

                </Select>
                {errors.unit && <p className='error-text'>{errors.unit}</p>}
              </FormControl>
              <TextField
                fullWidth
                variant="filled"
                label="Price"
                value={formData.price}
                onChange={handleChange}
                name="price"
                error={!!errors.price}
                helperText={errors.price}
                disabled={status !== 'open' && !isEditing}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {formatCurrency(0).replace(/\d|\.|,/g, '')}
                    </InputAdornment>
                  ),
                }}
              />


              {/* <TextField
                fullWidth
                type="date"
                variant="filled"
                label="Manufacture Date"
                InputLabelProps={{ shrink: true }}
                value={formData.manufactureDate}
                onChange={handleChange}
                name="manufactureDate"
                error={!!errors.manufactureDate}
                helperText={errors.manufactureDate}
                disabled={status !== 'open' && !isEditing}
              />
              <TextField
                fullWidth
                type="date"
                variant="filled"
                label="Expiry Date"
                InputLabelProps={{ shrink: true }}
                value={formData.expiryDate}
                onChange={handleChange}
                name="expiryDate"
                error={!!errors.expiryDate}
                helperText={errors.expiryDate}
                disabled={status !== 'open' && !isEditing}
              />
 */}

            </Box>
            {/* <Box mb={3} display="flex" gap={2}>
              <TextField
                fullWidth
                variant="filled"
                label="Price"
                value={formData.price}
                onChange={handleChange}
                name="price"
                error={!!errors.price}
                helperText={errors.price}
                disabled={status !== 'open' && !isEditing}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {formatCurrency(0).replace(/\d|\.|,/g, '')}
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                fullWidth
                variant="filled"
                label="Discount Percentage"
                value={formData.discountPercentage}
                onChange={handleChange}
                name="discountPercentage"
                type="number"
                disabled={status !== 'open' && !isEditing}
              />

              <TextField
                fullWidth
                variant="filled"
                label="Offer Price"
                type="number"
                value={formData.offerPrice}
                onChange={handleChange}
                name="offerPrice"
                disabled={status !== 'open' && !isEditing}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {formatCurrency(0).replace(/\d|\.|,/g, '')}
                    </InputAdornment>
                  ),
                }}
              />


            </Box> */}

          </>
        )}
        {isMultiple && (
          <TableContainer>
            <Table className='table'>
              <TableHead>
                <TableRow>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Unit</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Sub Title</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {multipleProducts.map((product, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <TextField
                        name="quantity"
                        type="number"
                        value={product.quantity}
                        error={!!errors[`quantity_${index}`]}
                        helperText={errors[`quantity_${index}`]}
                        onChange={(e) => handleMultipleChange(index, e)}
                        disabled={status !== 'open' && !isEditing}
                      />
                    </TableCell>
                    <TableCell>
                      <Select
                        name="unit"
                        value={product.unit}
                        onChange={(e) => handleMultipleChange(index, e)}
                        error={!!errors[`unit_${index}`]}
                        helperText={errors[`unit_${index}`]}
                        disabled={status !== 'open' && !isEditing}
                      >
                        <MenuItem value="Liter">Liter</MenuItem>
                        <MenuItem value="Gram">Gram</MenuItem>
                        <MenuItem value="Kilogram">Kilogram</MenuItem>
                        <MenuItem value="Milliliter">Milliliter</MenuItem>
                        <MenuItem value="Pack of">Pack of</MenuItem>
                        <MenuItem value="Piece">Piece</MenuItem>
                      </Select>
                    </TableCell>
                    <TableCell>
                      <TextField
                        name="price"
                        type="number"
                        value={product.price}
                        onChange={(e) => handleMultipleChange(index, e)}
                        disabled={status !== 'open' && !isEditing}
                        error={!!errors[`price_${index}`]}
                        helperText={errors[`price_${index}`]}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              {formatCurrency(0).replace(/\d|\.|,/g, '')}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <TextField
                        name="subTitle"
                        type="text"
                        value={product.subTitle ?? ''}
                        onChange={(e) => handleMultipleChange(index, e)}
                        disabled={status !== 'open' && !isEditing}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {isMultiple && (
          <IconButton
            color="primary"
            onClick={addProductRow}
            style={{ marginTop: 20 }}
          >
            <AddIcon />
          </IconButton>
        )}

        <Box mb={3}>

          <Grid container spacing={2} justifyContent="flex-start">
            {formData.images &&
              formData.images.length > 0 &&
              formData.images.map((img, index) => (
                <Grid
                  item
                  key={`image-${index}`}
                  xs={6}
                  sm={4}
                  md={3}
                  lg={2}
                >
                  <Card sx={{ position: "relative" }}>
                    <CardMedia
                      component="img"
                      image={typeof img === "string" ? `${API_BASE}${img}` : URL.createObjectURL(img)}
                      alt={`Image ${index + 1}`}
                      sx={{
                        width: "100%",
                        height: 120,
                        objectFit: "contain",
                        backgroundColor: "#f9f9f9",
                        borderRadius: "4px",
                        filter: status !== "open" && !isEditing ? "grayscale(50%)" : "none",
                        pointerEvents: status !== "open" && !isEditing ? "none" : "auto",
                      }}
                    />

                    {(status === "open" || isEditing) && (
                      <IconButton
                        onClick={() => handleRemoveImage(index)}
                        sx={{
                          position: "absolute",
                          top: 5,
                          right: 5,
                          backgroundColor: "rgba(255,0,0,0.7)",
                          color: "#fff",
                          "&:hover": { backgroundColor: "red" },
                          width: 24,
                          height: 24,
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    )}

                    <CardContent sx={{ textAlign: "center", p: 1 }}>
                      <Typography variant="body2" fontWeight={500}>
                        Image {index + 1}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
          </Grid>


          <input
            type="file"
            name="images"
            multiple
            accept="image/*"
            onChange={handleFileChange}
            disabled={status !== "open" && !isEditing}
            style={{ marginTop: "10px" }}
          />

          {errors.images && <p className="error-text">{errors.images}</p>}


          <div className="form-check" style={{ marginTop: "10px" }}>
            <input
              type="checkbox"
              className="form-check-input"
              checked={!!formData.isVisible}
              onChange={(e) =>
                setFormData({ ...formData, isVisible: e.target.checked })
              }
              disabled={status !== "open" && !isEditing}
            />
            <label className="form-check-label">Is Available</label>
          </div>
        </Box>






        {(status === 'open' || isEditing || status === 'draft') && (
          <Box className="button">
            {/* <Button variant="contained" color="primary" onClick={handleSave}>
                            Save
                        </Button>*/}
            <Button variant="contained" color="primary" onClick={handleSubmit}>
              Submit
            </Button>
          </Box>
        )}

        {status === 'pending' && (
          <Box className="button">
            <Button variant="contained" color="success" onClick={() => handleStatusChange('accept')}>
              Accept
            </Button>
            <Button variant="contained" color="error" onClick={() => handleStatusChange('reject')}>
              Reject
            </Button>

          </Box>
        )}

        {(status === 'Approved' || status === 'rejected') && !isEditing && (
          <Box className="button">
            <Button variant="contained" color="warning" onClick={handleEdit}>
              Edit Product
            </Button>
          </Box>
        )}

        <Box mt={3}>
          {message && <p>{message}</p>}
        </Box>
      </form>
    </div>
  );
}

export default AddProduct;